import { heroCards } from '@/mocks/cinemaData';

export default function HeroSection() {
  return (
    <section id="top" className="relative isolate overflow-hidden">
      <div className="absolute inset-0 -z-20">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20stylized%20cinema%20themed%20background%20with%20sweeping%20deep%20crimson%20and%20warm%20amber%20light%20rays%20through%20dark%20atmospheric%20haze%2C%20soft%20film%20grain%20and%20bokeh%20sparks%2C%20painterly%20gradient%20texture%20evoking%20a%20large%20screen%20in%20a%20dark%20hall%2C%20no%20text%2C%20high%20contrast%20deep%20tones%20for%20readable%20overlay&width=1920&height=1080&seq=qx-hero-bg-01&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-primary-950/80 via-foreground-950/70 to-foreground-950/85" aria-hidden="true" />

      <div className="mx-auto w-full max-w-7xl px-4 pb-14 pt-28 md:px-6 md:pb-20 md:pt-36">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs text-background-100 backdrop-blur">
            <i className="ri-movie-2-line" aria-hidden="true" />
            各端访问 · 内容导览 · 常见问题
          </span>
          <h1 className="mt-5 font-heading text-3xl font-semibold leading-tight text-background-50 md:text-5xl">
            秋霞影院在线观看：手机版、电脑版、网页版与 APP 一次看懂
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
            这是一个把「秋霞影院在线观看」相关访问方式集中整理的中文信息页。你可以先了解手机版、电脑版、网页版与 APP 下载各自的特点，再按需查看手机浏览器观看与手机在线看的完整流程，最后用影片分类导览快速找到想看的方向。
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <a
              href="#overview"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-arrow-down-line" aria-hidden="true" />
              从站点概览开始
            </a>
            <a
              href="#desktop"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-computer-line" aria-hidden="true" />
              对比各端差异
            </a>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:mt-16 lg:grid-cols-4">
          {heroCards.map((card) => (
            <a
              key={card.id}
              href={`#${card.id}`}
              className="group flex flex-col rounded-lg border border-background-50/20 bg-background-50/10 p-4 backdrop-blur transition-colors hover:border-accent-400/60 hover:bg-background-50/15 md:p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-background-50/15 text-accent-300">
                <i className={`${card.icon} text-xl`} aria-hidden="true" />
              </span>
              <span className="mt-4 text-[11px] uppercase tracking-wider text-accent-300">{card.tag}</span>
              <span className="mt-1 font-heading text-lg font-semibold text-background-50">{card.title}</span>
              <span className="mt-2 flex-1 text-sm leading-relaxed text-background-200">{card.desc}</span>
              <span className="mt-4 inline-flex items-center gap-1 text-sm text-background-100 transition-colors group-hover:text-accent-300">
                前往了解
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}